// extracted by mini-css-extract-plugin
export var flowchartContainer = "_b-0";